<template>
  <div>
    <div class="customerbox">
      <!-- <el-input v-model="CustomerAbbreviation" placeholder="选择单位" readonly /> -->
      <el-autocomplete
        id="autocomplete"
        ref="autocomplete"
        v-model="currentSearch"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
        @blur="blurFun"
        style="flex: 1; margin-right: 5px"
        :popper-append-to-body="false"
      ></el-autocomplete>
      <!--      @keyup.enter.native="enterFun" -->
      <el-button size="mini" type="primary" @click="onCustomerDialog"
        >请选择</el-button
      >
    </div>
    <customer-dialog
      ref="customerDialog"
      in-dialog
      selectable
      :multiple="multiple"
      custype="供应商"
      @select="setCustomer"
      :typeList="typeList"
    />
  </div>
</template>
<script>
import customerDialog from "@/components/basicinfo/basic/logistics/listDialog";
export default {
  components: {
    customerDialog,
  },
  props: {
    value: {},
    state: {
      type: String,
      default: "",
    },
    monthly: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    typeList:{
      default: () => [1,2,3]
    }
  },
  data() {
    return {
      currentSearch: this.state,
      restaurants: [],
      timeout: null,
      api: require("@/api/ba/tradeUnit").default,
    };
  },
  watch: {
    state() {
      this.currentSearch = this.state;
    },
  },
  computed: {},
  methods: {
    enterFun() {
      if (this.restaurants.length > 0) {
        this.currentSearch = this.restaurants[0].Name;
        let obj = {
          value: this.restaurants[0].Name,
          Id: this.restaurants[0].Id,
          Name: this.restaurants[0].Name,
        };
        this.$emit("restaurants", obj);
        this.$refs.autocomplete.suggestions = [];
      }
    },
    onCustomerDialog() {
      this.$refs.customerDialog.open().then((that) => {
        let query = {
          MonthlyClosing: this.monthly
        }

        that.getData(query);
      });
    },
    setCustomer(cus) {
      this.currentSearch = cus.Name;
      let obj = {
        value: cus.Name,
        Id: cus.Id,
        Name: cus.Name,
      };
      this.$emit("restaurants", cus);
    },
    querySearchAsync(queryString, cb) {
      var tradeUnitType=1;
      if(this.typeList.length>0){
        if(this.typeList.length==1){
          tradeUnitType=this.typeList[0]-1;
        }
      }
      this.api
        .list2({
          pageIndex: 1,
          pageSize: 10,
          TradeUnitName: queryString,
          TradeUnitType: tradeUnitType,
          MonthlyClosing : this.monthly
        })
        .then((res) => {
          let arr = [];
          res.Data.forEach((e) => {
            e.value = e.TradeUnitName;
            arr.push(e);
          });
          this.restaurants = arr;
          var restaurants = this.restaurants;
          var results = restaurants;
          cb(results);
        });
    },
    handleSelect(item) {
      
      console.log("item",item)
      this.$emit("restaurants", item);
    },
    blurFun(item) {
      if (!this.currentSearch) {
        let obj = {
          value: "",
          Id: "",
          Name: "",
        };
        this.$emit("restaurants", obj);
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-autocomplete-suggestion{
  width: auto!important;
}
.customerbox {
  width: 100%;
  display: flex;
}
</style>
